import { StyleSheet } from 'react-native'
import { StyleProps } from 'react-native-reanimated'

export const styles = StyleSheet.create<StyleProps>({
  input: {
    outlineWidth: 0
  }
})
